import { View, Text, Dimensions } from "react-native";
import React from "react";
import { tests, width } from "../../imports";
import { useDispatch, useSelector } from "react-redux";
import MyText from "../../components/custom/MyText";
import translate from "../../functions/translate";
import { Image } from "react-native";
import { femaleColor, gray, maleColor, primary, white } from "../../colors";
import { useEffect } from "react";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import {
  LineChart,
  BarChart,
  PieChart,
  ProgressChart,
  ContributionGraph,
  StackedBarChart,
} from "react-native-chart-kit";
import { useState } from "react";
import weightByAge from "../../api/test/growth/weightByAge";
import { ScrollView } from "react-native-gesture-handler";
import heightByAge from "../../api/test/growth/heightByAge";
import headByAge from "../../api/test/growth/headByAge";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import MyButton from "../../components/custom/MyButton";
import saveGrowthTest from "../../api/test/growth/saveGrowthTest";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";

export default function GrowthTestInput({ route }) {
  const navigation = useNavigation();
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const isFocused = useIsFocused();
  const [loading, setLoading] = useState(false);
  const [input, setInput] = useState({
    weightKilos: null,
    weightGrams: null,
    height: null,
    head: null,
  });

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#A7CA8D"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }
  }, [isFocused]);

  const next = () => {
    let w = 0;
    if (route.params.testType === "WeightByAge") {
      w = +input.weightKilos + +input.weightGrams / 1000;
    } else if (route.params.testType === "HeadSizeByAge") {
      w = +input.head;
    } else if (route.params.testType === "HeightByAge") {
      w = +input.height;
    }

    saveGrowthTest(route.params.childId, route.params.testType, w).then(
      ({ data }) => {
        if (data.status === 200) {
          navigation.navigate("GrowthTest", {
            childId: route.params.childId,
            testType: route.params.testType,
            title: route.params.title,
          });
        }
      }
    );
  };

  return (
    <KeyboardAwareScrollView
      enableOnAndroid
      extraHeight={100}
      style={{ flex: 1, height: "100%" }}
    >
      <View style={{ alignItems: "center", width: "100%" }}>
        <View
          style={{
            height: Dimensions.get("window").height,
            marginTop: -1 * Dimensions.get("window").height,
            backgroundColor: "#A7CA8D",
            width: "100%",
          }}
        ></View>
        <View style={{ alignItems: "center" }}>
          <View style={{ backgroundColor: "#A7CA8D" }}>
            <View
              style={{
                backgroundColor: "#A7CA8D",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 10,
                width: Dimensions.get("screen").width,
                minHeight: 100,
                flexDirection: "row",
                paddingHorizontal: 10,
              }}
            >
              <View style={{ flex: 5 }}>
                <View>
                  <MyText
                    style={{
                      fontSize: 30,
                      marginTop: 10,
                      marginHorizontal: 10,
                      color: white,
                    }}
                  >
                    {translate("grow test")}
                  </MyText>
                </View>
                <View
                  direction={main.rtl ? "rtl" : "ltr"}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    marginTop: 10,
                  }}
                ></View>
              </View>
              <View style={{ flex: 2 }}>
                <Image
                  source={tests}
                  style={{ width: "100%", height: 90 }}
                  resizeMode="contain"
                />
              </View>
            </View>
          </View>
        </View>
      </View>
      <View
        style={{
          alignItems: "center",
          padding: 10,
          justifyContent: "center",
        }}
      >
        <MyText style={{ fontSize: 20, color: primary }}>
          {route.params.title}
        </MyText>
        {route.params.testType === "HeightByAge" && (
          <View style={{ alignItems: "center", marginTop: 10 }}>
            <MyText>
              {translate("please enter you child height in centimeters")}
            </MyText>
            <MyInputWithLabel
              name="height"
              keyboardType="number-pad"
              style={{ width: 250 }}
              setInput={setInput}
              maxLength={3}
            />
            <MyButton
              onPress={next}
              style={{ width: 200, marginTop: 10, paddingVertical: 10 }}
              text={translate("next step")}
            />
          </View>
        )}
        {route.params.testType === "HeadSizeByAge" && (
          <View style={{ alignItems: "center", marginTop: 10 }}>
            <MyText style={{ textAlign: "center" }}>
              {translate("please enter you child head size in centimeters")}
            </MyText>
            <MyInputWithLabel
              name="head"
              keyboardType="number-pad"
              style={{ width: 250 }}
              setInput={setInput}
              maxLength={2}
            />
            <MyButton
              onPress={next}
              style={{ width: 200, marginTop: 10, paddingVertical: 10 }}
              text={translate("next step")}
            />
          </View>
        )}
        {route.params.testType === "WeightByAge" && (
          <View style={{ alignItems: "center", marginTop: 10 }}>
            <MyText style={{ textAlign: "center" }}>
              {translate("please enter you child weight")}
            </MyText>
            <View style={{ marginTop: 20, flexDirection: "row" }}>
              <View style={{ alignItems: "center", marginHorizontal: 10 }}>
                <MyText>{translate("kilograms")}</MyText>
                <MyInputWithLabel
                  name="weightKilos"
                  keyboardType="number-pad"
                  style={{ width: width / 3 }}
                  setInput={setInput}
                  maxLength={3}
                />
              </View>
              <View style={{ alignItems: "center", marginHorizontal: 10 }}>
                <MyText>{translate("grams")}</MyText>
                <MyInputWithLabel
                  name="weightGrams"
                  keyboardType="number-pad"
                  style={{ width: width / 3 }}
                  setInput={setInput}
                  maxLength={3}
                />
              </View>
            </View>
            <MyButton
              onPress={next}
              style={{ width: 200, marginTop: 10, paddingVertical: 10 }}
              text={translate("next step")}
            />
          </View>
        )}
      </View>
    </KeyboardAwareScrollView>
  );
}
